module.exports = __webpack_public_path__ + "media/images/icon-svg/close-white-1965479539370bcec594114c5260027d.svg";